import { Outlet } from 'react-router-dom'
import { useState } from 'react'
import Sidebar from './Sidebar'
import Header from './Header'

export default function Layout() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  
  // Create callback functions with proper typing
  const handleSetMobileMenuOpen = (open: boolean) => {
    setIsMobileMenuOpen(open)
  }
  
  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar isMobileOpen={isMobileMenuOpen} setIsMobileOpen={handleSetMobileMenuOpen} />
      <div className="lg:pl-64">
        <Header isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={handleSetMobileMenuOpen} />
        <main className="py-6">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}